import { isEmpty } from "lodash";
import type { ReactNode } from "react";
import { Fragment, useMemo, useRef } from "react";

interface Props<TData> {
  data: TData[];
  getItemHidden?: (line: TData) => boolean | undefined;
  renderContent: (line: TData) => ReactNode | TData[];
}

function ButtonGroup<TData>(props: Props<TData>) {
  const { data, renderContent, getItemHidden } = props;

  const _renderContent = useRef(renderContent);
  const _getItemHidden = useRef(getItemHidden);

  const renderChildren = useMemo(() => {
    const recursive = (d: TData[]) => {
      if (!d || isEmpty(d)) {
        return null;
      }

      return d.map((item, index) => {
        const content = _renderContent.current(item);
        const hidden = _getItemHidden.current?.(item) ?? false;
        const isArrayContent = Array.isArray(content);

        return (
          <Fragment key={index}>
            {hidden ? <></> : isArrayContent ? recursive(content as TData[]) : content}
          </Fragment>
        );
      });
    };

    return recursive(data);
  }, [data]);

  return <Fragment>{renderChildren}</Fragment>;
}

export default ButtonGroup;
